/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Subtract_Frame_From_EndInputs */



/**
* | output |
* | --- |
* | "Subtract 1 Frame From End" |
*
* @param {Shortcut_Keys_Name_Subtract_Frame_From_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_subtract_frame_from_end = /** @type {((inputs?: Shortcut_Keys_Name_Subtract_Frame_From_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Subtract_Frame_From_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Soustraire 1 image a la fin")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ziehe 1 Frame vom Ende ab")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottrai 1 fotogramma dalla fine")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вычтите 1 кадр из конца")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restar 1 cuadro del final")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从末尾减去 1 帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最後から1フレーム減算")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंत से 1 फ्रेम घटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Subtraia 1 quadro do final.")
	return /** @type {LocalizedString} */ ("Subtract 1 Frame From End")
});